import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import SalemanForm from "@components/forms/SalemanForm";
import styles from "./style.module.scss";
import PriceForm from "@components/forms/PriceForm";

const PriceAddEdit = () => {
  const params = useParams()
  const { id: priceId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!priceId ? 'Agregar' : 'Editar'} Precio`}
      backUrl="/user/price-management"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "priceForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <PriceForm
        formId="priceForm"
        id={priceId}
        saveRedirectUrl="/user/price-management"
      ></PriceForm>

    </PageContainer>
  );
}

export default PriceAddEdit;
